/** Query flag set on cross-app login so the destination shows the notice once. */
export const MAINTENANCE_NOTICE_QUERY_PARAM = 'show-maintenance-notice';
